import { createSelector } from 'reselect';

// selectors
const viewsSelector = (state) => state.views;
const loadingSelector = (state) => state.loading;
const matchupSelector = (state) => state.matchup;
const languageSelector = (state) => state.cofig?.language ?? 'en';
const getDeviceInteraction = (state) => state.config?.deviceInteraction;

// reselect function
export const getPlayerListState = createSelector(
    [viewsSelector, loadingSelector, matchupSelector, languageSelector, getDeviceInteraction],
    (views, loading, matchup, language, deviceInteraction) => (
        {
            views,
            loading,
            data: matchup,
            language,
            deviceInteraction
        }
    )
);
